/**
 * Iter XX.70 — LockedInsightCard
 *
 * A single locked insight. Preserves the REAL headline + category +
 * severity band, but hides the body. Tapping the card opens the
 * upgrade sheet (parent-provided).
 *
 * Iter XX.70.1 — swapped the CSS-drawn lock shape for a proper
 * `lucide-react` Lock icon so the affordance reads instantly on
 * mobile. The word "Locked" remains for screen readers +
 * unambiguous UX.
 */
import React from "react";
import { Lock } from "lucide-react";

const SEVERITY_BADGE = {
  high:   { label: "PRIMARY",   className: "bg-emerald-900/30 text-emerald-400/80 border-emerald-900" },
  medium: { label: "SUPPORTING", className: "bg-amber-900/30 text-amber-400/80 border-amber-900" },
  low:    { label: "NOTE",      className: "bg-slate-800/40 text-slate-500 border-slate-800" },
};

export default function LockedInsightCard({ insight, onClick }) {
  const sev = SEVERITY_BADGE[insight.severity] || SEVERITY_BADGE.medium;
  return (
    <button
      type="button"
      data-testid={`video-review-insight-card-${insight.rank}-locked`}
      aria-label={`Locked insight — ${insight.title}. Continue with Gully Plus to see this.`}
      onClick={onClick}
      className="w-full text-left rounded-xl border border-dashed border-slate-700 bg-slate-950/50 p-3 hover:bg-slate-950/70 transition-colors group"
    >
      <div className="flex items-center gap-2 mb-1">
        <span
          data-testid={`video-review-insight-severity-${insight.rank}`}
          className={`inline-block rounded-full border px-1.5 py-0.5 text-[10px] uppercase tracking-wider ${sev.className}`}
        >
          {sev.label}
        </span>
        <span
          data-testid={`video-review-insight-category-${insight.rank}`}
          className="text-[11px] text-slate-500"
        >
          {insight.category}
        </span>
        <span className="ml-auto flex items-center gap-1 text-[11px] text-slate-500 group-hover:text-slate-400"
              data-testid={`video-review-insight-card-${insight.rank}-lock-indicator`}>
          <Lock size={12} strokeWidth={2} aria-hidden />
          <span>Locked</span>
        </span>
      </div>
      <div
        data-testid={`video-review-insight-title-${insight.rank}`}
        className="text-sm font-medium text-slate-300"
      >
        {insight.title}
      </div>
      <div className="mt-1.5 text-[11px] text-slate-500">
        Continue with Gully Plus to see this.
      </div>
    </button>
  );
}
